import React from "react";
import TailwindPageWrapper from "../components/generic/TailwindPageWrapper";
import Hero from "../components/generic/Hero";
import WhatIsTaoluSection from "../components/taoluDetailsPage/WhatIsTaoluSection";
import CriteriaSection from "../components/taoluDetailsPage/CriteriaSection";
import FormatsSection from "../components/taoluDetailsPage/FormatsSection";
import AgeGroupsSection from "../components/taoluDetailsPage/AgeGroupsSection";
import ProcessSection from "../components/taoluDetailsPage/ProcessSection";
import TraditionSection from "../components/taoluDetailsPage/TraditionSection";
import RulesSection from "../components/taoluDetailsPage/RulesSection";
import CTASection from "../components/taoluDetailsPage/CTASection";

function TaoluDetailsPage() {
  return (
    <TailwindPageWrapper>
      <div className="-mt-24">
        <Hero
          className="hero-details"
          site_call="taolu_details_page"
          next_section="what-is-taolu-section"
        />
        <WhatIsTaoluSection />
        <CriteriaSection />
        <FormatsSection />
        <AgeGroupsSection />
        <ProcessSection />
        <TraditionSection />
        <RulesSection />
        <CTASection />
      </div>
    </TailwindPageWrapper>
  );
}

export default TaoluDetailsPage;
